export enum TasFallbackOption {
    NotifyAndMarketOrder = 1,
    NotifyAndDayLimitOrder = 2,
    NotifyOnly = 3
}

export function getTasFallbackOptionLabel(option: TasFallbackOption): string {
    switch (option) {
        case TasFallbackOption.NotifyAndMarketOrder:
            return "Notify and create a Market Order";
        case TasFallbackOption.NotifyAndDayLimitOrder:
            return "Notify and create a Day Limit Order";
        case TasFallbackOption.NotifyOnly:
            return "Notify me";
        default:
            return "Unknown Option";
    }
}

export const AllTasFallbackOptions: TasFallbackOption[] = [
    TasFallbackOption.NotifyAndMarketOrder,
    TasFallbackOption.NotifyAndDayLimitOrder,
    TasFallbackOption.NotifyOnly
];